import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { map } from 'lodash-es';
import { IVendorConnectConfirmation } from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import { VendorIdSource } from '@portal/app/dashboard/integrations/shared/constants';
import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import { IVendorAccounts } from '../../models/IVendorAccounts';

export class PodSightsHandler implements VendorHandler {
  prepareRequestObjectToInitiateVendor(): IVendorInitiateRequest {
    return {
      queryParams: {},
      pathParams: { vendorId: VendorIdSource.podsights }
    };
  }

  handleVendorInitiateResponse(): void {
    // No action needed for plaintext vendors
  }

  confirmVendor(): IVendorConnectConfirmation {
    throw new Error('Method not implemented.');
  }

  prepareRequestObjectToConfigureVendor(
    accounts: IVendorAccounts[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.podsights,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        clientAccountName: account.clientAccountName
      }))
    };
  }

  prepareRequestToConfirmVendor(
    confirmationData: Record<string, string>
  ): IVendorOAuthConfirmationRequest {
    const apiUrl = confirmationData.apiUrl || '';
    const urlParams = this.extractParamsFromUrl(apiUrl);

    return {
      userSecret: urlParams.token || '',
      apiKey: urlParams.organizationId || '',
      fields: urlParams.fields || ''
    };
  }

  private extractParamsFromUrl(url: string): {
    token: string;
    organizationId: string;
    fields: string;
  } {
    if (!url?.trim()) {
      return { token: '', organizationId: '', fields: '' };
    }

    try {
      const urlObj = new URL(url);
      const params = urlObj.searchParams;

      return {
        token: params.get('token') || '',
        organizationId: params.get('pk') || params.get('organization_id') || '',
        fields: params.get('fields') || ''
      };
    } catch (error) {
      console.error('Error parsing Podsights URL:', error);
      return { token: '', organizationId: '', fields: '' };
    }
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: IVendorAccounts[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.podsights,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId
      })),
      dsInstanceIds
    };
  }
}
